import React, { useContext, useEffect, useState } from "react";
import AuthCardLayout from "../AuthCardLayout";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import AppContext from "../../../context/Context";
import SikkaError from "../../common/SikkaError";
import apiCall from "../../../services/apiCall";
import authenticationService from "../../../services/authenticationService";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  faArrowAltCircleLeft,
  faLock,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormLabel, FormSelect } from "react-bootstrap";
import { Alert, Badge, Spinner } from "react-bootstrap";
import { info } from "sass";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import AddPayment from "../../admin-user-common/Billing/AddPayment";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import ButtonIcon from "../../common/ButtonIcon";
import { findCardLogo, hostName } from "../../../helpers/utils";
import ReferralCode from "../../common/ReferralCode";
import default_card from "../../../assets/img/icons/creditcard-general.png"

const TwoFactorAuthentication = () => {
  const location = useLocation();
  const history = useHistory();

  const [authenticationCode, setAuthenticationCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isAuthBtnClicked, setIsAuthBtnClicked] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [resetButtonClicked, setResetButtonClicked] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [mobileCode, setMobileCode] = useState("");
  const [verificationCodeShow, setverificationCodeShow] = useState(false);
  const [recoveryStatus, setRecoveryStatus] = useState(false);
  // const [error, setError] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [selectedPayment, setSelectedPayment] = useState({});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [isPayment, setIsPayment] = useState(true);
  const [formValue, setFormValue] = useState({}); 
  const [defaultActiveKey, setDefaultActiveKey] = useState("credit");
  const {
    loginUserDetails,
    setLoginUserDetails,
    setIsValidLogin,
    isValidLogin,
    loginResponse,
  } = useContext(AppContext);
  const isApiPlusExist =
    loginUserDetails?.is_partner == "1" &&
    loginUserDetails.user_type?.toLowerCase() !== "User".toLowerCase()
      ? sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false
      : false;

  const [paymentCards, setPaymentCards] = useState([]);
  const [referralCode, setReferralCode] = useState("");

  const state = location.state || {};

  const AuthenticateUser = (e) => {
    e?.preventDefault();
    if (authenticationCode) {
      let body = {
        username: state.email, // you will get this when user login
        password: state.password, // same
        userOtp: authenticationCode,
      };
      if (isApiPlusExist) {
        body["redirect_url"] = isApiPlusExist["redirect_url"];
        body["callback_key"] = isApiPlusExist["callback_key"];
        body["request"] = isApiPlusExist["request"];
        body["referral_code_by"] = referralCode;
        body["project_id"] = isApiPlusExist["project_id"];
        body["source_project_id"] = isApiPlusExist["source_project_id"]
          ? isApiPlusExist["source_project_id"]
          : "";

        body["steps"] =
          selectedPaymentMethod == "add_new_payment"
            ? "add_new_payment"
            : "use_default_payment";

        if (selectedPaymentMethod == "add_new_payment") {
          if (defaultActiveKey == "credit") {
            const dateValue = formValue["credit_card_expiration_date"]?.split(
              "/"
            );

            if (selectedPaymentMethod == "add_new_payment") {
              const monthValue = dateValue[0];
              const yearValue = dateValue[1]?.slice(2);
              body["card_details"] = {};
              body["card_details"] = {
                type_of_payment: defaultActiveKey,
                card_number: formValue.credit_card_number,
                expiration_date: `${monthValue}/${yearValue}`,
                address: formValue.address,
                state: formValue.state,
                city: formValue.city,
                zip: formValue.zip,
                email_id: formValue.email_id?.toLowerCase(),
                first_name: formValue.first_name,
                last_name: formValue.last_name,
                cvv: formValue.credit_security_code,
                host: hostName(window.location.href),
              };
            }
          }

          if (defaultActiveKey == "ach") {
            body["card_details"] = {};
            body["card_details"] = {
              type_of_payment: defaultActiveKey,
              name_on_account: formValue.ach_name_on_account,
              bank_name: formValue.ach_bank_name,
              account_number: formValue.ach_account_number,
              routing_number: formValue.ach_routing_number,
              address: formValue.address,
              state: formValue.state,
              city: formValue.city,
              zip: formValue.zip,
              email_id: formValue.email_id?.toLowerCase(),
              first_name: formValue.first_name,
              last_name: formValue.last_name,
              host: hostName(window.location.href),
              account_type: "ach",
            };
          }
        } else {
          body["selected_payment_id"] = selectedPayment?.customer_payment_id;
          body["selected_profile_id"] = selectedPayment?.customer_profile_id;
        }
      }
      setIsAuthBtnClicked(true);
      authenticationService
        .authenticateUser(body)
        .then((res) => {
          localStorage.setItem("isLoggedIn", true);
          setTimeout(() => {
            if (isApiPlusExist) {
              window.location.href = res.data?.url;
            }
          }, 2000);

          const message = isApiPlusExist
            ? res.data?.message
            : "Successfully Logged In";
          sessionStorage.removeItem("api_plus_plus");
          sessionStorage.removeItem("pastedLinkCount");
          if (!isApiPlusExist) {
            toast.success(message);
            setIsValidLogin(true);
            if (loginUserDetails.is_partner == "0") {
              history.push(`${process.env.PUBLIC_URL}/admin/dashboard`);
            } else {
              if (loginUserDetails.crm_id) {
                localStorage.setItem("contractExpiryModel", "true");
              }else{
                localStorage.removeItem("contractExpiryModel");
              }
              history.push(`${process.env.PUBLIC_URL}/user/applications`);
            }
            FetchRecoveryQuestionStatus(loginUserDetails.dev_id);
          }
        })
        .catch((error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
        })
        .finally(() => {
          setIsAuthBtnClicked(false);
        });
    } else {
      setErrorMessage("Authentication code should not be empty.");
    }
  };

  const timeoutDuration = 5 * 60 * 1000;

  useEffect(() => {
    if (!isValidLogin && !isApiPlusExist) {
      const timeoutId = setTimeout(() => {
        history.push(`${process.env.PUBLIC_URL}/authentication/login`);
        toast.error(
          "Session Timeout: You have been inactive for a while. Please re-enter your login credentials to continue."
        );
      }, timeoutDuration);

      // Cleanup timeout when the component unmounts or isValidLogin changes
      return () => clearTimeout(timeoutId);
    }
  }, [isValidLogin]);

  useEffect(() => {
    let body = {
      devID: loginUserDetails.dev_id,
    };
    authenticationService
      .Get2FAQuestions("reset_2fa_garq", body)
      .then((response) => {
        if (!response.data.items.length == 0) {
          setQuestions(response.data.items);
        } else {
          setRecoveryStatus(true);
        }
      })
      .catch((error) => {});
  }, []);

  //resest 2fa code
  function reset2faclick() {
    setResetButtonClicked(true);
  }
  
  const handleKeyDown = (e) => {
    if (e.key.toLowerCase() === "enter") {
      e.preventDefault();
      AuthenticateUser();
    }
  };

  const verifyCodeMobile = (e) => {
  e.preventDefault();
  if (mobileCode) {
    showLoader();
    let body = {
      devID: loginUserDetails.dev_id,
      verCode: mobileCode,
      username: loginUserDetails.user_name,
    };
    authenticationService
      .POSTMobileCode("reset_2fa_parvc", body)
      .then((response) => {
        if (response.data.status == "Success") {
          // Update login state first
          setLoginUserDetails(response?.data?.items);
          setIsValidLogin(true);
          localStorage.setItem("isLoggedIn", "true");
          
          const resMessage = response.data.message.toString();
          toast.success(resMessage);
          
          // Verify session is established before navigating
          authenticationService
            .whoisme()
            .then((whoIsRes) => {
              // Session is valid, safe to navigate
              hideLoader();
              setTimeout(() => {
                if (response?.data?.items?.is_partner == "0") {
                  window.location.href = `${process.env.PUBLIC_URL}/admin/settings/profile`;
                } else {
                  window.location.href = `${process.env.PUBLIC_URL}/user/settings/profile`;
                }
              }, 500);
            })
            .catch((whoIsError) => {
              // Session not established, try one more time after delay
              setTimeout(() => {
                authenticationService
                  .whoisme()
                  .then((whoIsRes) => {
                    hideLoader();
                    if (response?.data?.items?.is_partner == "0") {
                      window.location.href = `${process.env.PUBLIC_URL}/admin/settings/profile`;
                    } else {
                      window.location.href = `${process.env.PUBLIC_URL}/user/settings/profile`;
                    }
                  })
                  .catch((retryError) => {
                    hideLoader();
                    toast.error("Session could not be established. Please login again.");
                    setTimeout(() => {
                      window.location.href = `${process.env.PUBLIC_URL}/authentication/login`;
                    }, 2000);
                  });
              }, 1000);
            });
        }
      })
      .catch((error) => {
        if (error.response.data?.attempts === 5 || error.response.data?.errorCode === "LOCKED") {
          toast.error("Too many attempts. Redirecting to login...");
          hideLoader();
          setTimeout(() => {
            history.push(`${process.env.PUBLIC_URL}/authentication/login`);
          }, 1000);
          return;
        }   
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        hideLoader();
      });
  }
};

  const validateQuestions = (e) => {
    e.preventDefault();
    if (selectedQuestion && answer) {
      showLoader();
      let body = {
        devID: loginUserDetails.dev_id,
        answer: answer,
        queId: selectedQuestion,
        username: loginUserDetails.user_name,
      };
      authenticationService
        .POST2FAQuestions("reset_2fa_para", body)
        .then((response) => {
          if (response.data.status == "Success") {
            setverificationCodeShow(true);
          }
          const resMessage = response.data.message.toString();
          toast.success(resMessage);
          hideLoader();
        })
        .catch((error) => {
          if (error.response.data?.attempts === 5 || error.response.data?.errorCode === "LOCKED") {
            toast.error("Too many attempts. Redirecting to login...");
            hideLoader();
            history.push(`${process.env.PUBLIC_URL}/authentication/login`);
            return;
          }   
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          hideLoader();
        });
    }
  };

  const handlePaymentFormSubmit = () => {
    setIsPayment(false);
  };

  const FetchRecoveryQuestionStatus = (user_dev_id) => {
    let params = {
      devid: user_dev_id,
    };
    apiCall
      .servertrip("GET", "recovery_questions_status", loginUserDetails, params)
      .then((res) => {
        if (res.data?.is_account_recovery_enabled) {
          localStorage.removeItem("accountRecoveryModel");
          setRecoveryStatus(false);
        } else {
          localStorage.setItem("accountRecoveryModel", true);
          setRecoveryStatus(true);
        }
      })
      .catch((error) => {
        
      });
  };

  useEffect(() => {
    if (isApiPlusExist) {
      if (loginResponse?.cards) {
        if (loginResponse?.cards?.length > 0) {
          const userCards = loginResponse?.user_cards
            ? JSON.parse(loginResponse?.user_cards)
            : [];
          const cards = loginResponse?.cards.map((item) => {
            let foundCard = userCards.find(
              (userCard) =>
                userCard.customerPaymentProfileId == item.customer_payment_id
            );
            item["card_number"] =
              item.card_number || foundCard?.payment?.Item?.cardNumber;
            item["is_default"] = item.is_default == "yes" ? true : false;

            return item;
          });

          const defaultPayment = cards?.find((item) => item?.is_default);
          setPaymentCards(cards);
          setSelectedPayment(defaultPayment || {});
          setSelectedPaymentMethod("use_default_payment");
        } else {
          setSelectedPaymentMethod("add_new_payment");
          setPaymentCards([]);
        }
      } else {
        setSelectedPaymentMethod("add_new_payment");
        setPaymentCards([]);
      }
    }
  }, []);
  
  // useEffect(() => {
  //   if (isApiPlusExist) {
  //     if (paymentCards.length > 0) {
  //       setIsPayment(false);
  //     }
  //   }
  // }, [paymentCards, isApiPlusExist]);

  if (isApiPlusExist) {
    return (
    <>
        <AuthCardLayout>
          {isPayment ? (
            <>
              <Row className="mb-2">
                <Col>
                  <ReferralCode
                    setReferralCode={setReferralCode}
                    referralCode={referralCode}
                  />
                  <hr />
                  <Row className="mb-2">
                    <Col>
                      <h5 id="brand-text">Payment Methods</h5>
                    </Col>
                  </Row>
                  {paymentCards.length > 0 && (
                    <>
                      {paymentCards.map((item, itemIndex) => {
                        return (
                          <FormGroup key={itemIndex} check className="mb-1">
                            <Input
                              name="use_default_payment"
                              type="radio"
                              value={item?.customer_payment_id}
                              defaultChecked={
                                item?.customer_payment_id ==
                                selectedPayment?.customer_payment_id
                              }
                              onChange={(e) => {
                                setSelectedPayment(item);
                                setSelectedPaymentMethod(e.target.value);
                              }}
                              className="mr-2"
                            />
                            <img
                              key={item?.card_logo + itemIndex}
                              src={
                                findCardLogo(item?.card_logo)?.logoUrl
                                  ? findCardLogo(item?.card_logo)?.logoUrl
                                  : default_card
                              }
                              alt={
                                item?.card_logo || `${itemIndex}_card_logo`
                              }
                              style={{ height: "1.5em" }}
                            />
                            <Label className="ml-2" check>
                              {selectedPaymentMethod ==
                              item?.customer_payment_id ? (
                                <b>
                                  {item?.card_logo}{" "}
                                  {item?.card_number
                                    ? `: ${item?.card_number}`
                                    : ""}
                                    {/* {maskNumber(item?.customer_payment_id)} */}
                                </b>
                              ) : (
                                <>
                                  {item?.card_logo}{" "}
                                  {item?.card_number
                                    ? `: ${item?.card_number}`
                                    : ""}
                                  {/* {maskNumber(item?.customer_payment_id)} */}
                                </>
                              )}
                            </Label>
                          </FormGroup>
                        );
                      })}
                    </>
                  )}
                  <FormGroup check>
                    <Input
                      name="use_default_payment"
                      type="radio"
                      value={"add_new_payment"}
                      onChange={(e) => {
                        setSelectedPayment({});
                        setSelectedPaymentMethod(e.target.value);
                      }}
                      defaultChecked={selectedPaymentMethod == "add_new_payment"}
                    />
                    <Label check>
                      {selectedPaymentMethod == "add_new_payment" ? (
                        <b>Add New Payment</b>
                      ) : (
                        "Add New Payment"
                      )}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              {/* <ReferralCode
                setReferralCode={setReferralCode}
                isApplyBtnShow={false}
                referralCode={referralCode}
              /> */}

              {selectedPaymentMethod == "add_new_payment" && (
                <>
                <AddPayment
                  setFormValue={setFormValue}
                  formValue={formValue}
                  handlePaymentFormSubmit={handlePaymentFormSubmit}
                  setDefaultActiveKey={setDefaultActiveKey}
                  defaultActiveKey={defaultActiveKey}
                  setIsActive={setIsPayment}
                  showAddButton={true}
                  showCancelButton={false}
                  addButtonText={"Continue"}
                  isApiCalled={false}
                  showVerificationNotice={false}
                  submitButtonCustomClass={isApiPlusExist ? "sai_button" : ""}
                />
                </>
              )}

              {selectedPaymentMethod !== "add_new_payment" && (
                <>
                <Row className="">
                  <Col className="d-flex justify-content-end align-items-end">
                    <ButtonIcon
                      // color="outline-light"
                      size="sm"
                      icon="Sync"
                      className={`ml-1 mt-lg-0 mb-2 ${
                        isApiPlusExist ? " sai_button" : " text-light"
                      }`}
                      iconClassName="fs--2"
                      onClick={() => {
                        if (selectedPaymentMethod) {
                          setIsPayment(false);
                        }
                      }}
                    >
                      Continue
                    </ButtonIcon>
                  </Col>
                </Row>
                </>
              )}
            </>
          ) : (
            <>
              {!resetButtonClicked ? (
                <>
                  <Row
                    style={{
                      display: "grid",
                      justifyContent: "center",
                      padding: "2%",
                    }}
                    className="text-center mb-5"
                  >
                    <Col>
                      <div style={{ marginBottom: "2em" }}>
                        <h4
                          className={`mb-0 ${
                            isApiPlusExist && "sai_light_text"
                          }`}
                        >
                          Two-Factor Authentication
                        </h4>
                        <p style={{ fontSize: "0.8em" }} className="mt-2">
                          Enter the code from your{" "}
                          <b>Authentication app</b> or{" "}
                          <b>Recovery code</b>.
                        </p>
                      </div>
                      <Form onSubmit={AuthenticateUser}>
                        <FormGroup className="mb-3">
                          <Input
                            placeholder="XXXXXX"
                            onChange={({ target }) =>
                              setAuthenticationCode(target.value)
                            }
                            onKeyDown={handleKeyDown}
                            value={authenticationCode}
                            type="number"
                          />
                          {errorMessage && (
                            <SikkaError
                              error={errorMessage}
                              className="mt-1"
                            />
                          )}
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Button
                            color="primary"
                            block
                            className={`mt-3 ${
                              isApiPlusExist && "sai_button"
                            }`}
                            type="submit"
                            // onClick={AuthenticateUser}
                            disabled={isAuthBtnClicked}
                          >
                            Authenticate
                          </Button>
                        </FormGroup>
                      </Form>
                    </Col>

                    <Col xs="auto">
                      <small>
                        <p style={{ display: "flex" }}>
                          Click{" "}
                          <Link
                            onClick={reset2faclick}
                            className={`${
                            isApiPlusExist &&
                            " sai_light_text text_underline"
                          }`}
                          >
                            &nbsp;<b>here</b>&nbsp;
                          </Link>{" "}
                          to reset your 2FA and regain access.
                        </p>
                      </small>
                    </Col>
                  </Row>

                  <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
                    <Col xs="auto">
                      <h4 className={`fs--1 text-600 text-lowercase`}>
                        <Link
                          className={`${
                            isApiPlusExist &&
                            " sai_light_text text_underline"
                          }`}
                          to={`${process.env.PUBLIC_URL}/authentication/login`}
                        >
                          Go To Login Page
                        </Link>
                      </h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <Badge
                        style={{
                          cursor: "pointer",
                        }}
                        bg="light"
                        text="dark"
                        className="me-2"
                        onClick={() => {
                          const lastPaymentMethod = selectedPaymentMethod;
                          const lastFormValue = formValue;
                          if (lastPaymentMethod === "add_new_payment") {
                            setFormValue(lastFormValue);
                          } else {
                            setSelectedPaymentMethod(lastPaymentMethod);
                          }

                          setIsPayment(true);
                        }}
                      >
                        Do you want to change the payment method?
                      </Badge>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {!recoveryStatus ? (
                    <>
                      {!verificationCodeShow ? (
                        <>
                          <Row
                            style={{
                              display: "grid",
                              justifyContent: "center",
                              padding: "2%",
                            }}
                            className="text-center mb-5"
                          >
                            <Col>
                              <div style={{ marginBottom: "2em" }}>
                                <h4
                                  className={`mb-0 ${
                                    isApiPlusExist && "sai_light_text"
                                  }`}
                                >
                                  Account Recovery
                                </h4>
                                <p
                                  style={{ fontSize: "0.8em" }}
                                  className="mt-2"
                                >
                                  🔐 Please select a security question from the
                                  dropdown to proceed with account recovery.
                                </p>
                              </div>

                              <Form onSubmit={validateQuestions}>
                                <FormGroup className="mb-3">
                                  <Input
                                    id="exampleSelect"
                                    name="select"
                                    type="select"
                                    required
                                    value={selectedQuestion}
                                    onChange={(e) =>
                                      setSelectedQuestion(e.target.value)
                                    }
                                  >
                                    <option value="" disabled>
                                      -- Select a question --
                                    </option>
                                    {questions.map((question, index) => (
                                      <option
                                        key={index}
                                        value={question.que_id}
                                      >
                                        {question.que_text}
                                      </option>
                                    ))}
                                  </Input>
                                </FormGroup>
                                <FormGroup className="mb-3">
                                  <Input
                                    required
                                    placeholder={"Answer"}
                                    onChange={({ target }) => {
                                      setAnswer(`${target.value}`);
                                    }}
                                    value={answer}
                                    type="text"
                                  />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                  <Button
                                    color="primary"
                                    block
                                    className={`mt-3 ${isApiPlusExist && "sai_button"}`}
                                    type="submit"
                                    // disabled={isAuthBtnClicked}
                                  >
                                    Confirm & Proceed
                                  </Button>
                                </FormGroup>
                              </Form>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row
                            style={{
                              display: "grid",
                              justifyContent: "center",
                              padding: "2%",
                               // marginBottom: "3em",
                            }}
                            className="text-center mb-5"
                          >
                            <Col>
                              <div style={{ marginBottom: "2em" }}>
                                <h4
                                  className={`mb-0 ${
                                    isApiPlusExist && "sai_light_text"
                                  }`}
                                >
                                  Enter the verification code
                                </h4>
                                <p
                                  style={{ fontSize: "0.8em" }} className="mt-2"
                                >
                                  🔐 Please verify your identity by entering the code
                                  sent to your registered mobile or email.
                                </p>
                              </div>

                              <Form onSubmit={verifyCodeMobile}>
                                <FormGroup className="mb-3">
                                  <Input
                                    placeholder={"XXXXXX"}
                                    // value={email}
                                    required
                                    onChange={({ target }) => {
                                      setMobileCode(`${target.value}`);
                                    }}
                                    onKeyDown={(e) => {
                                      if (
                                        e.key.toLowerCase() === "enter"
                                      ) {
                                        e.preventDefault();
                                        verifyCodeMobile(e);
                                      }
                                    }}
                                    value={mobileCode}
                                    type="number"
                                  />
                                  {errorMessage && (
                                    <>
                                    <SikkaError
                                      error={errorMessage}
                                      className="mt-1"
                                    />
                                    </>
                                  )}
                                </FormGroup>
                                <FormGroup className="mb-3">
                                  <Button
                                    color="primary"
                                    block
                                    className={`mt-3 ${
                                      isApiPlusExist && "sai_button"
                                    }`}
                                    type="submit"
                                    // onClick={AuthenticateUser}
                                    // disabled={isAuthBtnClicked}
                                  >
                                   Verify & Continue
                                  </Button>
                                </FormGroup>
                              </Form>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Row
                        style={{
                          display: "grid",
                          justifyContent: "center",
                          padding: "2%",
                           // marginBottom: "3em",
                        }}
                        className="text-center mb-5"
                      >
                        <Col>
                          <div style={{ marginBottom: "2em" }}>
                            <h4 className="mb-0">
                              🚨 Recovery Not Set Up!
                            </h4>
                            <p
                              style={{ fontSize: "0.8em" }}
                              className="mt-2"
                            >
                               We couldn’t find account recovery options for you. No
                               worries! Contact support or your admin to regain access.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
                        <Col xs="auto">
                          <h4 className="fs--1 text-600 text-lowercase">
                            <Link
                              to={`${process.env.PUBLIC_URL}/authentication/login`}
                            >
                              Go To Login Page
                            </Link>
                          </h4>
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              )}
              {loader}
            </>
          )}
        </AuthCardLayout>
      </>
    );
  }

  return (
    <>
    <AuthCardLayout>
      {!resetButtonClicked ? (
        <>
          <Row
            style={{
              display: "grid",
              justifyContent: "center",
              padding: "2%",
            }}
            className="text-center mb-5"
          >
            <Col>
              <div style={{ marginBottom: "2em" }}>
                <h4 className="mb-0">Two-Factor Authentication</h4>
                <p style={{ fontSize: "0.8em" }} className="mt-2">
                  Enter the code from your <b>Authentication app</b> or{" "}
                  <b>Recovery code</b>.
                </p>
              </div>
              <Form onSubmit={AuthenticateUser}>
                <FormGroup className="mb-3">
                  <Input
                    placeholder="XXXXXX"
                    onChange={({ target }) => setAuthenticationCode(target.value)}
                    onKeyDown={handleKeyDown}
                    value={authenticationCode}
                    type="number"
                  />
                  {errorMessage && (
                    <SikkaError error={errorMessage} className="mt-1" />
                  )}
                </FormGroup>
                <FormGroup className="mb-3">
                  <Button
                    color="primary"
                    block
                    className="mt-3"
                    type="submit"
                    disabled={isAuthBtnClicked}
                  >
                    Authenticate
                  </Button>
                </FormGroup>
              </Form>
            </Col>

            <Col xs="auto">
              <small>
                <p style={{ display: "flex" }}>
                  Click{" "}
                  <Link
                    onClick={reset2faclick}
                    style={{ color: "#0d6efd", cursor: "pointer", textDecoration: "underline" }}
                  >
                   &nbsp;<b>here</b>&nbsp;
                  </Link>{" "}
                  to reset your 2FA and regain access.
                </p>
              </small>
            </Col>
          </Row>
          <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
            <Col xs="auto">
              <h4 className="fs--1 text-600 text-lowercase">
                <Link to={`${process.env.PUBLIC_URL}/authentication/login`}>
                  Go To Login Page
                </Link>
              </h4>
            </Col>
          </Row>
        </>
      ) : (
        <>
          {!recoveryStatus ? (
            <>
              {!verificationCodeShow ? (
                <>
                  <Row
                    style={{
                      display: "grid",
                      justifyContent: "center",
                      padding: "2%",
                    }}
                    className="text-center mb-5"
                  >
                    <Col>
                      <div style={{ marginBottom: "2em" }}>
                        <h4 className="mb-0">Account Recovery</h4>
                        <p style={{ fontSize: "0.8em" }} className="mt-2">
                         🔐 Please select a security question from the
                          dropdown to proceed with account recovery.
                        </p>
                      </div>

                      <Form onSubmit={validateQuestions}>
                        <FormGroup className="mb-3">
                          <Input
                            id="exampleSelect"
                            name="select"
                            type="select"
                            required
                            value={selectedQuestion}
                            onChange={(e) =>
                              setSelectedQuestion(e.target.value)
                            }
                          >
                            <option value="" disabled>
                              -- Select a question --
                            </option>
                            {questions.map((question, index) => (
                              <option key={index} value={question.que_id}>
                                {question.que_text}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Input
                            required
                            placeholder={"Answer"}
                            onChange={({ target }) => {
                              setAnswer(`${target.value}`);
                            }}
                            value={answer}
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Button
                            color="primary"
                            block
                            className="mt-3"
                            type="submit"
                          >
                            Confirm & Proceed
                          </Button>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row
                    style={{
                      display: "grid",
                      justifyContent: "center",
                      padding: "2%",
                    }}
                    className="text-center mb-5"
                  >
                    <Col>
                      <div style={{ marginBottom: "2em" }}>
                        <h4 className="mb-0">Enter the verification code</h4>
                        <p style={{ fontSize: "0.8em" }} className="mt-2">
                        🔐 Please verify your identity by entering the code
                          sent to your registered mobile or email.
                        </p>
                      </div>

                      <Form onSubmit={verifyCodeMobile}>
                        <FormGroup className="mb-3">
                          <Input
                            placeholder={"XXXXXX"}
                            required
                            onChange={({ target }) => {
                              setMobileCode(`${target.value}`);
                            }}
                            onKeyDown={(e) => {
                              if (e.key.toLowerCase() == "enter") {
                                e.preventDefault();
                              }
                            }}
                            value={mobileCode}
                            type="number"
                          />
                          {errorMessage && (
                            <SikkaError
                              error={errorMessage}
                              className="mt-1"
                            />
                          )}
                        </FormGroup>

                        <FormGroup className="mb-3">
                          <Button
                            color="primary"
                            block
                            className="mt-3"
                            type="submit"
                          >
                            Verify & Continue
                          </Button>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                </>
              )}
            </>
          ) : (
            <>
              <Row
                style={{
                  display: "grid",
                  justifyContent: "center",
                  padding: "2%",
                }}
                className="text-center mb-5"
              >
                <Col>
                  <div style={{ marginBottom: "2em" }}>
                    <h4 className="mb-0">🚨 Recovery Not Set Up!</h4>
                    <p style={{ fontSize: "0.8em" }} className="mt-2">
                      We couldn't find account recovery options for you. No
                      worries! Contact support or your admin to regain access.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
                <Col xs="auto">
                  <h4 className="fs--1 text-600 text-lowercase">
                    <Link
                      to={`${process.env.PUBLIC_URL}/authentication/login`}
                    >
                      Go To Login Page
                    </Link>
                  </h4>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
      {loader}
    </AuthCardLayout>
    </>
  );
};

export default TwoFactorAuthentication;

const maskNumber = (number, side = "left") => {
  let strNum = typeof number == "string" ? number : number.toString();
  if (strNum) {
    let lastFour = strNum.slice(-4);
    let firstPart = strNum.slice(0, strNum.length - 4);
    let maskedPart = "X".repeat(firstPart.length);

    return side.toLowerCase() === "right"
      ? lastFour + maskedPart
      : maskedPart + lastFour;
  } else {
    return "";
  }
};